import { EnvironmentProviders, Provider, Type } from '@angular/core';
import {
  SHARED_AUTH_SESSION_MANAGER,
  SHARED_INVALID_SESSION_HANDLER,
  SharedAuthSessionManager,
  SharedInvalidSessionHandler,
} from './share-auth-session.types';

export interface ShareAuthSessionConfig {
  sessionManager: Type<SharedAuthSessionManager>;
  invalidSessionHandler?: Type<SharedInvalidSessionHandler>;
}

export function provideShareAuthSession(
  config: ShareAuthSessionConfig,
): (Provider | EnvironmentProviders)[] {
  const providers: (Provider | EnvironmentProviders)[] = [
    config.sessionManager,
    {
      provide: SHARED_AUTH_SESSION_MANAGER,
      useExisting: config.sessionManager,
    },
  ];

  if (config.invalidSessionHandler) {
    providers.push(
      config.invalidSessionHandler,
      {
        provide: SHARED_INVALID_SESSION_HANDLER,
        useExisting: config.invalidSessionHandler,
      },
    );
  }

  return providers;
}
